import FlexRow from '../FlexRow.vue';
import HugValue from './HugValue.vue';
import VariableStyledBar from './VariableStyledBar.vue';
import BarSlotWithValue from './BarSlotWithValue.vue';
export default {
  name: "BarWithValue",
  props: {
    value: {
      type: [Number, null],
      required: false,
      default: 3301
    },
    color: {
      type: String,
      required: true,
      default: "#312783"
    },
    align: {
      type: String,
      required: false,
      default: "right"
    },
    gap: {
      type: Number,
      required: false,
      default: 8
    },
    min: {
      type: Number,
      required: false,
      default: 0
    },
    max: {
      type: Number,
      required: false,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    tight: {
      type: Boolean,
      default: false
    },
    reverse: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 4
    }
  },
  components: {
    VariableStyledBar,
    HugValue,
    FlexRow,
    BarSlotWithValue
  },
  computed: {
    validValue() {
      return this.value !== null && this.value !== undefined;
    }
  }
};